module.exports = __webpack_public_path__ + "img/dash-icon8.040737f1.png";